import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';
import { DialogModule } from '@syncfusion/ej2-angular-popups';
import { DialogComponent as SyncfusionDialogComponent } from '@syncfusion/ej2-angular-popups';
import { WidgetType } from '../widgets/shared/widget-type.enum';
import { GridModule } from '@syncfusion/ej2-angular-grids';
import { DashboardService } from '../dashboard.service';
import { AddWidgetDialogComponentPreviewComponent } from "./add-widget-dialog-component-preview/add-widget-dialog-component-preview.component";
import { ParameterChangedData } from '../widgets/shared/abstract-widget.component';
import { GridLocalDataBaseComponent } from 'src/app/base/shared/grid-base/grid-local-data-base.component';

export interface WidgetSelectedData {
  widgetType: WidgetType;
  parameters: ParameterChangedData;
}

@Component({
    selector: 'app-add-widget-dialog',
    imports: [TranslateModule, DialogModule, DropDownListModule, ReactiveFormsModule, GridModule, AddWidgetDialogComponentPreviewComponent],
    templateUrl: './add-widget-dialog.component.html',
    styleUrl: './add-widget-dialog.component.scss'
})
export class AddWidgetDialogComponent extends GridLocalDataBaseComponent implements OnInit {

  @ViewChild('addWidgetDialog')
  public addWidgetDialog: SyncfusionDialogComponent;

  @Output()
  public widgetSelected: EventEmitter<WidgetSelectedData> = new EventEmitter<WidgetSelectedData>();

  public selectedWidgetType: WidgetType;

  private parameters: ParameterChangedData;

  constructor(
    translateService: TranslateService,
    private dashboardService: DashboardService
  ) {
    super(null, translateService, null);
  }

  public ngOnInit(): void {
    this.data = this.dashboardService.getListOfWidgetsUserCanAccess();
  }

  public onCloseAddWidgetDialog(): void {
    this.addWidgetDialog.hide();
    this.resetDialog();
  }

  public showAddWidgetDialog(): void {
    this.resetDialog();
    this.addWidgetDialog.show();
  }

  public hideAddWidgetDialog(): void {
    this.addWidgetDialog.hide();
  }

  public select(): void {
    this.widgetSelected.emit({widgetType: this.selectedWidgetType, parameters: this.parameters} as WidgetSelectedData);
  }

  public onRowSelected(args: any): void {
    this.selectedWidgetType = args.data.id;

  }

  public resetDialog(): void {
    this.selectedWidgetType = null;
    this.grid.refresh();
  }

  public parametersChanged(data: ParameterChangedData): void {
    this.parameters = data;
  }

  protected override initializeEditForm(data: any): void {
    throw new Error('Method not implemented.');
  }
  protected override getEditDialogTitleParams(rowData: any): object {
    throw new Error('Method not implemented.');
  }
}
